import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Constants } from "../Common/Constants";
import { goalsInsert, goalsList, goalsUpdate } from "../../Redux/Actions";
import { types } from "../../Redux/Actions/types";
import TextField from "../Common/Fields/TextField";
import ButtonCustom from "../Common/Fields/ButtonCustom";
import usePermissions from "../Common/Functions/usePermissions";

const GoalForm = () => {
  const dispatch = useDispatch();
  const { goalSingle } = useSelector((state) => state.Goals);
  // Permissions
  const addPermission = usePermissions(Constants.permission.GOAL_ADD);
  const editPermission = usePermissions(Constants.permission.GOAL_EDIT);

  // Initial values to Goal form
  const [initialValues, setInitialValues] = useState({
    title: "",
  });

  // Validations for Goal form
  const validationSchema = Yup.object().shape({
    title: Yup.string().required(Constants.required),
  });

  useEffect(() => {
    // Set initial values to pre fill goal form
    if (goalSingle?._id) {
      const editValue = {};
      for (const [key] of Object.entries(initialValues)) {
        if (goalSingle[key]) {
          editValue[key] = goalSingle[key];
        }
        setInitialValues(editValue);
      }
    }
  }, [goalSingle]);

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        // Add or update Goal API
        let submitFunc = goalsInsert(values);
        if (goalSingle._id) {
          values.id = goalSingle._id;
          submitFunc = goalsUpdate(values);
        }
        dispatch(submitFunc).then((response) => {
          if (response.error) {
            dispatch({
              type: types.ERROR_ALERT_VISIBLE,
              payload: response.error,
            });
          } else {
            dispatch({
              type: types.SUCCESS_ALERT_VISIBLE,
              payload: response.data.message,
            });
            dispatch({ type: types.GOALS_SINGLE, payload: "" });
            dispatch({ type: types.GOALS_FORM_MODEL, payload: "" });
          }
          dispatch(goalsList());
        });
      }}
    >
      {({ errors, touched }) => (
        <Form className="row">
          <div className="col-md-12 mb-2">
            <TextField
              type="text"
              name="title"
              className="form-control"
              errors={touched?.title ? errors?.title : undefined}
              touched={touched?.title}
              label={Constants.title}
            />
          </div>
          {((addPermission && !goalSingle?._id) ||
            (editPermission && goalSingle?._id)) && (
            <ButtonCustom label={Constants.submit} type="submit" />
          )}
        </Form>
      )}
    </Formik>
  );
};

export default GoalForm;
